import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { ExtendedBackgroundContainer } from '../../../atoms/extendedBackgroundContainer/ExtendedBackgroundContainer';

const QuoteBubble = styled.div`
  background-color: #fff;
  display: flex;
  border-radius: 20px;
  min-height: 200px;
  padding: 24px;
  position: relative;

  @media (max-width: 768px) {
    min-height: 150px;
  }

  &:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 25px;
    width: 0;
    border-top: 15px solid #fff;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
  }
`;

const Content = (section, locale) => {
  const { title, componentData } = section;

  const systemguideQuotesLang = componentData.filter((quote) => {
    const { excludeInLocales, includeOnlyInLocales } = quote;

    if (excludeInLocales && excludeInLocales.length) {
      return !excludeInLocales.includes(locale);
    }

    if (includeOnlyInLocales && includeOnlyInLocales.length) {
      return includeOnlyInLocales.includes(locale);
    }

    return true;
  });

  return (
    <div className="flex w-full flex-col flex-1 gap-10 px-8 lg:mx-auto max-w-6xl">
      {title && (
        <Typography as="h3" fontVariant="h4">
          {title}
        </Typography>
      )}
      <div className="flex flex-col min-[769px]:flex-row items-center lg:items-stretch justify-between gap-5">
        {systemguideQuotesLang.map((item) => (
          <Stack
            key={item.name}
            className="w-1/3 min-w-80 md:min-w-52 lg:min-w-60 max-w-80 h-full"
          >
            <QuoteBubble className="shadow-2xl h-3/4">
              <Typography
                fontVariant="sm"
                textAlign="left"
                className="!text-customGray-600"
              >
                &quot;{item.testimonial}&quot;
              </Typography>
            </QuoteBubble>
            <div className="flex flex-1 ml-[22px] mt-5 h-1/4 min-h-10">
              <img
                className="w-10 h-10 rounded-full"
                src={item.imgUrl}
                alt={`${item.imgAlt || item.name} | BusinessWith`}
                loading="lazy"
              />
              <Stack className="flex-1 ml-5 gap-0 h-10">
                <Typography
                  fontVariant="md"
                  textAlign="left"
                  className="w-fit font-bold"
                >
                  {item.name}
                </Typography>
                <Typography
                  fontVariant="sm"
                  textAlign="left"
                  className="w-fit !text-customGray-600"
                >
                  {item.role}
                </Typography>
                {item.company && (
                  <Typography
                    fontVariant="sm"
                    textAlign="left"
                    className="w-fit !text-customGray-600"
                  >
                    {item.company}
                  </Typography>
                )}
              </Stack>
            </div>
          </Stack>
        ))}
      </div>
    </div>
  );
};

const Testimonials = ({ section, locale, withStyledBg, wide, classNames }) =>
  withStyledBg ? (
    <>
      <ExtendedBackgroundContainer />
      <div className="bg-white py-10">{Content(section, locale)}</div>
    </>
  ) : (
    <div
      className={cx(
        'flex w-full flex-col flex-1 lg:mx-auto my-20 md:my-40 max-w-5xl',
        {
          'max-w-7xl': wide,
        },
        classNames
      )}
    >
      <div className="flex flex-col md:flex-row flex-1 justify-between">
        {Content(section, locale)}
      </div>
    </div>
  );

export default Testimonials;
